import axiosInstance from "./axiosInstance";

const clearSession = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  localStorage.removeItem("user_type");
  localStorage.removeItem("login_time");
};

const AuthService = {
  login: async (identifier, password) => {
    clearSession();

    const response = await axiosInstance.post("auth/login/", {
      identifier,
      password,
    });

    const data = response.data;

    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);
    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("user_type", data.user?.user_type || "");
    localStorage.setItem("login_time", new Date().toISOString());

    return data;
  },

  logout: () => {
    clearSession();
  },

  getCurrentUser: () => {
    const user = localStorage.getItem("user");

    try {
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error("Failed to read current user session.", error);
      return null;
    }
  },

  updateCurrentUser: (updates = {}) => {
    const currentUser = AuthService.getCurrentUser() || {};
    const nextUser = { ...currentUser, ...updates };

    localStorage.setItem("user", JSON.stringify(nextUser));

    window.dispatchEvent(
      new CustomEvent("grange:user-updated", {
        detail: { user: nextUser },
      })
    );

    return nextUser;
  },

  getToken: () => {
    return localStorage.getItem("access_token");
  },

  isAuthenticated: () => {
    return !!localStorage.getItem("access_token");
  },
};

export default AuthService;
